export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.997 20.5H5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0005 13.8284V3.92857C11.0005 3.41574 11.4482 3 12.0005 3C12.5527 3 13.0005 3.41574 13.0005 3.92857V13.8284L15.536 11.2929C15.9265 10.9024 16.5597 10.9024 16.9502 11.2929C17.3407 11.6834 17.3407 12.3166 16.9502 12.7071L12.7076 16.9497C12.317 17.3403 11.6839 17.3403 11.2933 16.9497L7.05071 12.7071C6.66018 12.3166 6.66018 11.6834 7.05071 11.2929C7.44123 10.9024 8.0744 10.9024 8.46492 11.2929L11.0005 13.8284Z"
      fill="currentColor"
    />
  </svg>
);
